module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_innovation-law_2.f7b63b79.png";